import { render, staticRenderFns } from "./AIInterview.vue?vue&type=template&id=60bd45e4&scoped=true&"
import script from "./AIInterview.vue?vue&type=script&lang=js&"
export * from "./AIInterview.vue?vue&type=script&lang=js&"
import style0 from "./AIInterview.vue?vue&type=style&index=0&id=60bd45e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd45e4",
  null
  
)

export default component.exports